"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetOwnerTypeToJSON = exports.AssetOwnerTypeFromJSONTyped = exports.AssetOwnerTypeFromJSON = exports.AssetOwnerType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var AssetOwnerType;
(function (AssetOwnerType) {
    AssetOwnerType["Admin"] = "Admin";
    AssetOwnerType["User"] = "User";
})(AssetOwnerType = exports.AssetOwnerType || (exports.AssetOwnerType = {}));
function AssetOwnerTypeFromJSON(json) {
    return AssetOwnerTypeFromJSONTyped(json, false);
}
exports.AssetOwnerTypeFromJSON = AssetOwnerTypeFromJSON;
function AssetOwnerTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AssetOwnerTypeFromJSONTyped = AssetOwnerTypeFromJSONTyped;
function AssetOwnerTypeToJSON(value) {
    return value;
}
exports.AssetOwnerTypeToJSON = AssetOwnerTypeToJSON;
